"use strict";

var _HeaderLayout;
import { UserMenuHolder } from '@autoguru/components';
import { CDN } from '@autoguru/global-configs';
import { HeaderLayout } from '@autoguru/header-layout';
import { Column, Columns } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LogoImage = /*#__PURE__*/_jsx(Picture, {
  aspectRatio: 5.1,
  height: 48,
  backgroundColor: "transparent",
  src: `${CDN}/images/logos/otto.svg`,
  altText: "Otto logo"
});
export const SimpleAppHeader = () => _HeaderLayout || (_HeaderLayout = /*#__PURE__*/_jsx(HeaderLayout, {
  safePaddings: true,
  children: /*#__PURE__*/_jsxs(Columns, {
    space: "5",
    children: [/*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      children: LogoImage
    }), /*#__PURE__*/_jsx(Column, {
      grow: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsx(Columns, {
        width: "full",
        space: "3",
        children: /*#__PURE__*/_jsx("span", {})
      })
    }), /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsx(UserMenuHolder, {})
    })]
  })
}));